namespace ui
{
	export namespace table
	{
		export namespace model
		{

			export class DefaultTableModel
				extends ui.table.model.AbstractTableModel<string[]>
			{
				public constructor( descriptor?: ITableModelDescriptor )
				{
					super();
				}
			}
		}
	}
}
